import React, { useState } from 'react';
import './FeaturedBouquets.css';

const FeaturedBouquets = () => {
  const [selectedTheme, setSelectedTheme] = useState('All');
  const [, setCartItems] = useState(0);

  const themes = ['All', 'Birthday', 'Love', 'Thank You', 'Sympathy', 'New Baby', 'Anniversary'];

  const bouquets = [
    {
      id: 1,
      name: 'Sunshine Delight',
      price: 45.99,
      image: 'https://images.unsplash.com/photo-1563241527-3004b7be0ffd?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'Birthday',
      description: 'Bright yellow sunflowers and daisies',
      rating: 4.8,
      reviews: 124
    },
    {
      id: 2,
      name: 'Romantic Roses',
      price: 65.99,
      image: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'Love',
      description: 'Classic red roses with baby\'s breath',
      rating: 4.9,
      reviews: 89
    },
    {
      id: 3,
      name: 'Gratitude Garden',
      price: 38.99,
      image: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'Thank You',
      description: 'Mixed seasonal flowers in warm tones',
      rating: 4.7,
      reviews: 67
    },
    {
      id: 4,
      name: 'Peaceful Memories',
      price: 55.99,
      image: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'Sympathy',
      description: 'Elegant white lilies and chrysanthemums',
      rating: 4.9,
      reviews: 45
    },
    {
      id: 5,
      name: 'Sweet Arrival',
      price: 42.99,
      image: 'https://images.unsplash.com/photo-1455659817273-f96807779a8a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'New Baby',
      description: 'Soft pastel flowers for new beginnings',
      rating: 4.8,
      reviews: 78
    },
    {
      id: 6,
      name: 'Eternal Love',
      price: 75.99,
      image: 'https://images.unsplash.com/photo-1496062031456-07b8f162a322?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      theme: 'Anniversary',
      description: 'Premium mixed roses and peonies',
      rating: 5.0,
      reviews: 156
    }
  ];

  const filteredBouquets = selectedTheme === 'All' 
    ? bouquets 
    : bouquets.filter(bouquet => bouquet.theme === selectedTheme);

  const handleAddToCart = (bouquet) => {
    setCartItems(prev => prev + 1);
    // Here you would typically add to a global cart state
    console.log(`Added ${bouquet.name} to cart`);
  };

  const handleQuickView = (bouquet) => {
    // Here you would typically open a modal or navigate to product page
    console.log(`Quick view for ${bouquet.name}`);
  };

  return (
    <section className="featured-bouquets" aria-label="Featured bouquets">
      <div className="featured-bouquets__container">
        <div className="featured-bouquets__header">
          <h2 className="featured-bouquets__title">Featured Bouquets</h2>
          <p className="featured-bouquets__subtitle">Our most loved arrangements, handpicked by our florists</p>
        </div>

        {/* Theme Filters */}
        <div className="featured-bouquets__filters">
          {themes.map((theme) => (
            <button
              key={theme}
              className={`filter-btn ${selectedTheme === theme ? 'filter-btn--active' : ''}`}
              onClick={() => setSelectedTheme(theme)}
            >
              {theme}
            </button>
          ))}
        </div>

        {/* Bouquet Cards */}
        <div className="featured-bouquets__grid">
          {filteredBouquets.map((bouquet) => (
            <div key={bouquet.id} className="bouquet-card">
              <div className="bouquet-card__image-container">
                <img 
                  src={bouquet.image} 
                  alt={bouquet.name}
                  className="bouquet-card__image"
                />
                <div className="bouquet-card__overlay">
                  <button 
                    className="bouquet-card__quick-view"
                    onClick={() => handleQuickView(bouquet)}
                    aria-label={`Quick view ${bouquet.name}`}
                  >
                    👁️ Quick View
                  </button>
                </div>
                <div className="bouquet-card__badge">
                  {bouquet.theme}
                </div>
              </div>

              <div className="bouquet-card__content">
                <h3 className="bouquet-card__name">{bouquet.name}</h3>
                <p className="bouquet-card__description">{bouquet.description}</p>
                
                <div className="bouquet-card__rating">
                  <span className="bouquet-card__stars">⭐</span>
                  <span className="bouquet-card__rating-value">{bouquet.rating}</span>
                  <span className="bouquet-card__reviews">({bouquet.reviews} reviews)</span>
                </div>

                <div className="bouquet-card__footer">
                  <div className="bouquet-card__price">
                    <span className="bouquet-card__currency">$</span>
                    <span className="bouquet-card__amount">{bouquet.price}</span>
                  </div>
                  <button 
                    className="bouquet-card__add-to-cart"
                    onClick={() => handleAddToCart(bouquet)}
                  >
                    🛒 Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="featured-bouquets__cta">
          <button className="featured-bouquets__view-all">
            View All Bouquets
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBouquets;